import React from 'react';

interface ErrorMsgProps {
    errMsg: React.ReactNode;
}

const ErrorMsg: React.FC<ErrorMsgProps> = props => {
    /* eslint-disable react/prop-types */
    const {errMsg} = props;
    return (
        <p className="error-msg">
            {errMsg}
        </p>
    );
};

export default ErrorMsg;
